import { NgModule } from '@angular/core';

import { FilterPipe } from '@core/pipes/filter.pipe';


import { HourMinutesPipe } from './hour-minutes.pipe';
import { LocalizedDatePipe } from './localized-date.pipe';
import { EntityNamePipe } from './entity-name.pipe';

@NgModule({
	declarations: [FilterPipe, HourMinutesPipe],
	// LocalizedDatePipe/EntityNamePipe are standalone (so standalone components
	// can import them directly too) — a standalone pipe can't sit in
	// `declarations`, but an NgModule can still re-export it to its own
	// consumers by listing it in both `imports` and `exports`.
	imports: [LocalizedDatePipe, EntityNamePipe],
	exports: [
		FilterPipe,
		HourMinutesPipe,
		LocalizedDatePipe,
		EntityNamePipe,
	],
})
export class CorePipesModule {}
